import { styled } from '@mui/material/styles';

export const CarouselViewport = styled('div', {
    name: 'Carousel',
    slot: 'viewport',
    skipSx: false,
})({
    overflow: 'hidden',
});
